import React, {Fragment} from 'react';

import PanelControlDelete from "../UI/ReactPanelControlDelete";
import DropdownProgressLevel from "../UI/ReactDropdownProgressLevel";
import DropdownProgress from "../UI/ReactDropdownProgress";
import DropdownAttitude from "../UI/ReactDropdownAttitude";
import DropdownWorkingAtYearAndLevel from "../UI/ReactDropdownWorkingAtYearAndLevel";
import DropdownQualification from "../UI/ReactDropdownQualification";
import UserInput from "../UI/ReactUserInput";

export default class ChildProgressReviewPanel extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = {
			data: this.props.data,
			mode: this.props.mode,
			panelNumber: this.props.panelNumber,
			displayErrors: this.props.displayErrors
		};

		this.onDirty = this.onDirty.bind(this);
		this.onClickDelete = this.onClickDelete.bind(this);
	}

	componentDidUpdate(prevProps, prevState)
	{
		if (this.props.displayErrors != this.state.displayErrors)
		{
			this.setState({displayErrors: this.props.displayErrors});
		}
	}

	getFormItems(object, formDefinition)
	{
		let n = object;

		for (let i in formDefinition) {
			let ref = formDefinition[i]['ref'];
			let data_item = formDefinition[i]['item_name'];
			let val = null;

			if (this.refs[ref] != null) {
				val = this.refs[ref].getValue();
			} else {
				if (formDefinition[i]['default'] != null) {
					val = formDefinition[i]['default'];
				} else {
					val = null;
				}
			}

			n[data_item] = val;
		}

		return n;
	}

	isDirtyFormItems()
	{
		let result = false ;
		const formDefinition = this.getFormDefinition();

		for (let i in formDefinition)
		{
			let ref = formDefinition[i]['ref'];

			if ( this.refs[ref] != null )
			{
				if (this.refs[ref].isDirty())
				{
					result = true;
				}
			}
		}

		return result ;
	}

	isValidFormItems()
	{
		let result = true ;
		const formDefinition = this.getFormDefinition();

		for (let i in formDefinition)
		{
			let ref = formDefinition[i]['ref'];

			if ( this.refs[ref] != null )
			{
				if (!this.refs[ref].isValid())
				{
					result = false;
					break ;
				}
			}
		}

		return result ;
	}

	isCompleteFormItems()
	{
		let notApplicable = false ;

		let result = true ;
		const formDefinition = this.getFormDefinition();

		for (let i in formDefinition)
		{
			const ref = formDefinition[i]['ref'];

			if ( this.refs[ref] != null )
			{
				let value = this.refs[ref].getValue() ;

				// Nasty hack to allow submission if Not Applicable is true for InputAttitude ( Attitude to Learning )
				// This entire component needs to be re-written to use react-hook-form in the longer term
				if ( ref === 'InputAttitude' && +value === 5 )
				{
					notApplicable = true
				}

				if ( value == formDefinition[i]['emptyValue'] && notApplicable === false )
				{
					result = false;
					break ;
				}
			}
		}

		return result ;
	}

	setDirtyFormItems( value )
	{
		let result = false ;
		const formDefinition = this.getFormDefinition();

		for (let i in formDefinition)
		{
			let ref = formDefinition[i]['ref'];

			if ( this.refs[ref] != null )
			{
				this.refs[ref].setDirty(value) ;
			}
		}

		return result ;
	}

	getFormData()
	{
		let dataItem = {} ;

		dataItem['review_id'] = this.state.data.review_id ;
		dataItem['achievement_id'] = this.state.data.achievement_id ;
		dataItem['expectation_achieved'] = null ;
		dataItem['description'] =  this.state.data.description;

		dataItem = this.getFormItems( dataItem, this.getFormDefinition()) ;

		if ( this.state.data.achievement_id == 0 )
		{
			dataItem['new'] = true ;
		}

		return dataItem ;
	}

	onDirty()
	{
		if ( this.props.onDirty != null )
		{
			this.props.onDirty();
		}
	}

	isValid ()
	{
		return this.isValidFormItems() ;
	}

	isComplete()
	{
		return this.isCompleteFormItems() ;
	}

	isDirty()
	{
		return this.isDirtyFormItems() ;
	}

	setDirty( value )
	{
		this.setDirtyFormItems( value );
	}
	
	getYearGroup( year_id )
	{
		// Default to year 1-8 if none provided
		let year_group_id = 1;

		switch ( +year_id )
		{
			case 14:
			case 15:
			case 17:
				year_group_id = 0 ;
				break ;
			case 1:
			case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
				year_group_id = 1 ;
				break;
            case 9:
            case 10:
            case 11:
            	year_group_id = 2 ;
            	break ;
			default:
				year_group_id = 1 ;
				break ;
		}

		return year_group_id ;
	}

	row2018EYFSContent()
	{
		var lineList=[];

		const fieldType = this.props.readonly === true || this.state.mode == 'view' ? 'readonly' : '';
		const obj = this.state.data;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-4' },
			React.createElement ( DropdownProgressLevel, {
				validation: { required: false },
				id: 'InputProgressAchieved',
				name: 'InputProgressAchieved',
				ref: 'InputProgressAchieved',
				label: '',
				errorText: 'Valid progress required',
				defaultValue: obj.progress_achieved,
				tabIndex: 3  + (6 * this.state.panelNumber),
				readOnly: fieldType,
				onDirty: this.onDirty,
				displayErrors:this.state.displayErrors,
				key: this.keyCount++
			}))) ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-4'},
			React.createElement ( DropdownProgress, {
				validation: { required: false },
				id: 'InputCurrentLevel',
				name: 'InputCurrentLevel',
				ref: 'InputCurrentLevel',
				label: '',
				errorText: 'Value required',
				defaultValue: obj.current_level,
				tabIndex: 3  + (6 * this.state.panelNumber),
				readOnly: fieldType,
				onDirty: this.onDirty,
				displayErrors:this.state.displayErrors,
				containerClassName: 'input-group',
				key: this.keyCount++
			}))) ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-4'},
			React.createElement ( DropdownProgress, {
				validation: { required: false },
				id: 'InputFinalPredictedLevel',
				name: 'InputFinalPredictedLevel',
				ref: 'InputFinalPredictedLevel',
				label: '',
				errorText: 'Value required',
				defaultValue: obj.final_predicted_level,
				tabIndex: 1  + (6 * this.state.panelNumber),
				readOnly: fieldType,
				onDirty: this.onDirty,
				displayErrors:this.state.displayErrors,
				containerClassName: 'input-group',
				key: this.keyCount++
			}))) ;


		return React.createElement ( 'div', { key: this.keyCount++, className: 'row'} , lineList );

	}

	row2018Content()
    {
        let lineList=[];

		const fieldType = this.props.readonly === true || this.state.mode == 'view' ? 'readonly' : '';

        const obj = this.state.data;

		const isScience = obj.description === 'Science' ;

        lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'},
            React.createElement ( DropdownAttitude, {
                validation: { required: false, isDate: false},
                id: 'InputAttitude',
                name: 'InputAttitude',
                ref: 'InputAttitude',
                label: '',
                errorText: 'Valid selection required',
                defaultValue: obj.attitude,
                tabIndex: 1 + (6 * this.state.panelNumber),
                readOnly: fieldType,
                displayErrors:this.state.displayErrors,
                onDirty: this.onDirty,
				includeNotApplicable: isScience,
                key: this.keyCount++
            }))) ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'},
			React.createElement ( DropdownAttitude, {
				validation: { required: false, isDate: false},
				id: 'InputAttitudeToHomework',
				name: 'InputAttitudeToHomework',
				ref: 'InputAttitudeToHomework',
				label: '',
				errorText: 'Valid selection required',
				defaultValue: obj.attitude_to_homework,
				tabIndex: 1 + (6 * this.state.panelNumber),
				readOnly: fieldType,
				displayErrors:this.state.displayErrors,
				onDirty: this.onDirty,
				includeNotApplicable: true,
				key: this.keyCount++
			}))) ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'},
			React.createElement ( DropdownProgressLevel, {
				validation: { required: false },
				id: 'InputProgressAchieved',
				name: 'InputProgressAchieved',
				ref: 'InputProgressAchieved',
				label: '',
				errorText: 'Valid progress required',
				defaultValue: obj.progress_achieved,
				tabIndex: 3  + (6 * this.state.panelNumber),
				readOnly: fieldType,
				onDirty: this.onDirty,
				displayErrors:this.state.displayErrors,
				key: this.keyCount++
			}))) ;

			lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-3'},
				React.createElement ( DropdownWorkingAtYearAndLevel, {
					validation: { required: false },
					id: 'InputAgeRelatedCurriculum',
					name: 'InputAgeRelatedCurriculum',
					ref: 'InputAgeRelatedCurriculum',
					label: '',
					year_id: this.props.year_id,
					errorText: 'Value required',
					defaultValue: obj.age_related_curriculum,
					tabIndex: 3  + (6 * this.state.panelNumber),
					readOnly: fieldType,
					onDirty: this.onDirty,
					displayErrors:this.state.displayErrors,
					containerClassName: 'input-group',
					key: this.keyCount++
				}))) ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-3'},
			React.createElement ( DropdownWorkingAtYearAndLevel, {
				validation: { required: false },
				id: 'InputFinalPredictedLevel',
				name: 'InputFinalPredictedLevel',
				ref: 'InputFinalPredictedLevel',
				year_id: this.props.year_id,
				label: '',
				errorText: 'Value required',
				defaultValue: obj.final_predicted_level,
				tabIndex: 1  + (6 * this.state.panelNumber),
				readOnly: fieldType,
				onDirty: this.onDirty,
				displayErrors:this.state.displayErrors,
				containerClassName: 'input-group',
				key: this.keyCount++
			}))) ;


        return React.createElement ( 'div', { key: this.keyCount++, className: 'row'} , lineList );

    }

	changeSubjectQualification ( achievement_id, qual )
	{
		let data = this.state.data ;

		data.ks4_qualification = qual ;

		if ( qual != 1 )
		{
			data.final_predicted_level = '' ;
		}

		this.setState ( { data: data }) ;
	}

	onQualChange ( achievement_id, qualification_id, text )
	{
		this.changeSubjectQualification( achievement_id, qualification_id ) ;
	}

	row2018ContentKS4()
	{
		var lineList = [];

		const fieldType = this.props.readonly === true || this.state.mode === 'view' ? 'readonly' : '';

		let obj = this.state.data;

		let classname = 'col-1 col-md-2';

		const isScience = obj.description === 'Science' ;

		lineList.push(
			<div key={this.keyCount++} className={classname}>
				<DropdownAttitude
					validation={{required: false, isDate: false}}
					id='InputAttitude'
					name='InputAttitude'
					ref='InputAttitude'
					label=''
					errorText='Valid selection required'
					defaultValue={obj.attitude}
					tabIndex={1 + (6 * this.state.panelNumber)}
					readOnly={fieldType}
					displayErrors={this.state.displayErrors}
					containerClassName='input-group'
					onDirty={this.onDirty}
					includeNotApplicable={isScience}
					key={'InputAttitude' + obj.achievement_id}/>
			</div>);

		lineList.push(
			<div key={this.keyCount++} className={classname}>
				<DropdownAttitude
					validation={{required: false, isDate: false}}
					id='InputAttitudeToHomework'
					name='InputAttitudeToHomework'
					ref='InputAttitudeToHomework'
					label=''
					errorText='Valid selection required'
					defaultValue={obj.attitude_to_homework}
					tabIndex={1 + (6 * this.state.panelNumber)}
					readOnly={fieldType}
					displayErrors={this.state.displayErrors}
					onDirty={this.onDirty}
					includeNotApplicable={true}
					key={'InputAttitudeToHomework' + obj.achievement_id}/>
			</div>);

		lineList.push(
			<div key={this.keyCount++} className={classname}>
				<DropdownProgressLevel
					validation={{required: false}}
					id='InputProgressAchieved'
					name='InputProgressAchieved'
					ref='InputProgressAchieved'
					label=''
					errorText='Valid progress required'
					defaultValue={obj.progress_achieved}
					tabIndex={3 + (6 * this.state.panelNumber)}
					readOnly={fieldType}
					onDirty={this.onDirty}
					displayErrors={this.state.displayErrors}
					key={'InputProgressAchieved' + obj.achievement_id}/>
			</div>);

		lineList.push(
			<div key={this.keyCount++} className='col-md-2'>
				<DropdownQualification
					ref='InputQualification'
					validation={{required: false}}
					displayErrors={this.props.displayErrors}
					label=''
					readOnly={fieldType}
					onDirty={this.onDirty}
					onChange={this.onQualChange.bind(this, this.state.data.achievement_id)}
					errorText='You must select a value'
					key={'InputQualification' + obj.achievement_id}
					defaultValue={obj.ks4_qualification}/>
			</div>);

		if ( this.state.data.ks4_qualification == '1' )
		{
			lineList.push(
				<div key={this.keyCount++} className='col-1 col-md-2'>
					<DropdownWorkingAtYearAndLevel
						validation={{required: false}}
						id='InputAgeRelatedCurriculum'
						name='InputAgeRelatedCurriculum'
						ref='InputAgeRelatedCurriculum'
						label=''
						year_id={this.props.year_id}
						errorText='Value required'
						defaultValue={obj.age_related_curriculum}
						tabIndex={3 + (6 * this.state.panelNumber)}
						readOnly={fieldType}
						onDirty={this.onDirty}
						displayErrors={this.state.displayErrors}
						containerClassName='input-group'
						key={'InputAgeRelatedCurriculum' + obj.achievement_id}/>
				</div>);

			lineList.push(
				<div key={this.keyCount++} className='col-1 col-md-2'>
					<DropdownWorkingAtYearAndLevel
						validation={{required: false}}
						id='InputFinalPredictedLevel'
						name='InputFinalPredictedLevel'
						ref='InputFinalPredictedLevel'
						year_id={this.props.year_id}
						label=''
						errorText='Value required'
						defaultValue={obj.final_predicted_level}
						tabIndex={1 + (6 * this.state.panelNumber)}
						readOnly={fieldType}
						onDirty={this.onDirty}
						displayErrors={this.state.displayErrors}
						containerClassName='input-group'
						key={'InputFinalPredictedLevel' + obj.achievement_id}/>
				</div>);
		}
		else
		{
			lineList.push(
				<div key={this.keyCount++} className='col-md-2'>
					<UserInput
						id='InputAgeRelatedCurriculum'
						name='InputAgeRelatedCurriculum'
						ref='InputAgeRelatedCurriculum'
						validation={{required: false}}
						displayErrors={this.props.displayErrors}
						label=''
						readOnly='readonly'
						onDirty={this.onDirty}
						errorText='You must select a value'
						key={'InputAgeRelatedCurriculum' + obj.achievement_id}
						containerClassName='input-group'
						value='Other'/>
				</div>);

			lineList.push(
				<div key={this.keyCount++} className='col-md-2'>
					<UserInput
						ref='InputFinalPredictedLevel'
						validation={{required: false}}
						displayErrors={this.props.displayErrors}
						label=''
						placeholder='Grade'
						readOnly={fieldType}
						onDirty={this.onDirty}
						errorText='You must select a value'
						key={'InputFinalPredictedLevelText' + obj.achievement_id}
						containerClassName='input-group'
						value={obj.final_predicted_level}/>
				</div>);
		}

		return <div key={this.keyCount++} className='row'>{lineList}</div>;

	}

	isKeyStage4()
	{
		return  this.props.year_id == '10' || this.props.year_id == '11' ? true : false ;
	}

	row2018Header()
	{
		const headers = this.getFormDefinition()

		return <div key={this.keyCount++} className='row'>{headers.map((item) =>
		{
			return <div key={this.keyCount++} style={{fontWeight: 'bold'}} className={item.headerClassName}>{item.headerTitle}</div>;
		})
		}</div>;
	}

	getFormDefinition()
	{
		let items = [] ;

		const year_group_id = this.getYearGroup(this.props.year_id) ;

		if ( this.isKeyStage4())
		{
			items = [
				{ref: 'InputAttitude', item_name: 'attitude', emptyValue: -1, headerClassName: 'col-md-2', headerTitle: 'Attitude To Learning'},
				{ref: 'InputAttitudeToHomework', item_name: 'attitude_to_homework', emptyValue: -1, headerClassName: 'col-md-2', headerTitle: 'Attitude to homework'},
				{ref: 'InputProgressAchieved', item_name: 'progress_achieved', emptyValue: 0, headerClassName: 'col-md-2', headerTitle: 'Progress Made'},
				{ref: 'InputQualification', item_name: 'ks4_qualification', emptyValue: -1, headerClassName: 'col-md-2', headerTitle: 'Qualification'},
				{ref: 'InputAgeRelatedCurriculum', item_name: 'age_related_curriculum', emptyValue: 0, headerClassName: 'col-md-2', headerTitle: 'Pupil currently working at'},
				{ref: 'InputFinalPredictedLevel', item_name: 'final_predicted_level', emptyValue: 0, headerClassName: 'col-md-2', headerTitle: 'Final Predicted Grade'},
			];
		}
		else if (  +year_group_id === 1 )
		{
			items = [
				{ref: 'InputAttitude', item_name: 'attitude', emptyValue: -1, headerClassName: 'col-md-2', headerTitle: 'Attitude To Learning'},
				{ref: 'InputAttitudeToHomework', item_name: 'attitude_to_homework', emptyValue: -1, headerClassName: 'col-md-2', headerTitle: 'Attitude To Homework'},
				{ref: 'InputProgressAchieved', item_name: 'progress_achieved', emptyValue: 0, headerClassName: 'col-md-2', headerTitle: 'Progress Made?'},
				{ref: 'InputAgeRelatedCurriculum', item_name: 'age_related_curriculum', emptyValue: 0, headerClassName: 'col-md-3', headerTitle: 'Pupil currently working at'},
				{ref: 'InputFinalPredictedLevel', item_name: 'final_predicted_level', emptyValue: 0, headerClassName: 'col-md-3', headerTitle: 'End of Year prediction'},
			];
		}
		else if ( +year_group_id === 0 )
		{
			items = [
				{ref: 'InputCurrentLevel', item_name: 'current_level', default: null, emptyValue: null, headerClassName: 'col-md-4', headerTitle: 'Progress Made?'},
				{ref: 'InputProgressAchieved', item_name: 'progress_achieved', emptyValue: 0, headerClassName: 'col-md-4', headerTitle: 'Pupil currently working at'},
				{ref: 'InputFinalPredictedLevel', item_name: 'final_predicted_level', emptyValue: 0, headerClassName: 'col-md-4', headerTitle: 'End of Year prediction '},
			];
		}
		else
		{
			// 9-11
			items = [
				{ref: 'InputAttitude', item_name: 'attitude', emptyValue: -1, headerClassName: 'col-md-2', headerTitle: 'Attitude To Learning'},
				{ref: 'InputAttitudeToHomework', item_name: 'attitude_to_homework', emptyValue: -1, headerClassName: 'col-md-2', headerTitle: 'Attitude to homework'},
				{ref: 'InputProgressAchieved', item_name: 'progress_achieved', emptyValue: 0, headerClassName: 'col-md-2', headerTitle: 'Progress Made'},
				{ref: 'InputAgeRelatedCurriculum', item_name: 'age_related_curriculum', emptyValue: 0, headerClassName: 'col-md-3', headerTitle: 'Pupil currently working at'},
				{ref: 'InputFinalPredictedLevel', item_name: 'final_predicted_level', emptyValue: 0, headerClassName: 'col-md-3', headerTitle: 'End of Year prediction'},
			];
		}

		return items;
	}

	renderPanel (  )
	{
		let lineList=[];

		const year_group_id = this.getYearGroup(this.props.year_id) ;

		lineList.push ( this.row2018Header()) ;

		if ( this.isKeyStage4())
		{
			lineList.push ( this.row2018ContentKS4()) ;
		}
        else if (  +year_group_id === 1 )
		{
			lineList.push ( this.row2018Content()) ;
        }
        else if ( +year_group_id === 0 )
		{
			lineList.push ( this.row2018EYFSContent()) ;
		}
        else
		{
			lineList.push ( this.row2018Content()) ;
        }

		return lineList ;
	}

	onClickDelete()
	{
		if ( this.props.onDelete != null )
		{
            this.props.onDelete ( this.props.data ) ;
		}
	}

	panelHeader ( title, allow_delete )
	{
		let disabled = true ;
		let handler =  null ;

		if ( allow_delete == 1 )
		{
			handler = this.onClickDelete ;
			disabled = false ;
		}

		return (
			<div className='panel-heading'>
				<span>{title}</span>
				<PanelControlDelete disabled={disabled} onClick={handler}/>
			</div>
		)
    }

	formRows ()
	{
		const obj = this.state.data ;

		return (
			<Fragment>
				{ this.panelHeader(obj.description, obj.allow_delete)}
				<div className='panel-body'>
					{ this.renderPanel() }
				</div>
			</Fragment>
		)
	}
	
	render() 
    {
		this.keyCount=0;

        return React.createElement('div', { key: this.keyCount++, className: 'panel panel-default panel-subject'}, this.formRows());
    }
};